export default {
  list: {},
  types: {},
};
